import type { WatchQueryFetchPolicy } from '@apollo/client';
import { useGetAvailableTimeslotsForBookingSessionQuery } from '@pm/graphql';
import { parseISO } from 'date-fns';
import { toPatientWallClock } from '../../utilities/patient-wall-clock';
export const useAppointmentTimeSlots = (
  bookingSessionId: string,
  date: Date,
  options?: { skip?: boolean; fetchPolicy?: WatchQueryFetchPolicy },
) => {
  const {
    data: availableTimeslotsData,
    loading,
    error,
  } = useGetAvailableTimeslotsForBookingSessionQuery({
    variables: {
      bookingSessionId,
      bookingDate: date.toISOString(),
    },
    fetchPolicy: options?.fetchPolicy ?? 'cache-and-network',
    skip: options?.skip,
  });

  const availableAppointmentTimes =
    availableTimeslotsData?.availableTimeSlotsForBookingSession ?? [];

  const availableTimeSlots = availableAppointmentTimes.map(
    ({ time, providerId, timeInPatientTimeZone, patientTimeZoneLabel }) => ({
      time: parseISO(time),
      wallClock: toPatientWallClock(parseISO(time), timeInPatientTimeZone),
      timeZoneLabel: patientTimeZoneLabel ?? undefined,
      providerId: providerId ? String(providerId) : undefined,
    }),
  );

  return {
    availableTimeSlots,
    loading,
    error,
  } as const;
};
